import React, { useState } from 'react';
import axios from 'axios';

const API_URL = '/api';

function FacilityModal({ facility, token, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    facilityName: facility?.facilityName || '',
    description: facility?.description || '',
    address: facility?.location?.address || '',
    lat: facility?.location?.coordinates?.lat || '',
    lon: facility?.location?.coordinates?.lon || '',
    timezone: facility?.location?.timezone || 'Europe/Istanbul',
    totalArea: facility?.totalArea || ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const data = {
      facilityName: formData.facilityName,
      description: formData.description,
      location: {
        address: formData.address,
        coordinates: {
          lat: parseFloat(formData.lat),
          lon: parseFloat(formData.lon)
        },
        timezone: formData.timezone
      },
      totalArea: parseInt(formData.totalArea)
    };

    try {
      if (facility) {
        await axios.put(`${API_URL}/facilities/${facility._id}`, data, {
          headers: { Authorization: `Bearer ${token}` }
        });
        alert('Tesis güncellendi');
      } else {
        await axios.post(`${API_URL}/facilities`, data, {
          headers: { Authorization: `Bearer ${token}` }
        });
        alert('Tesis eklendi');
      }
      onSuccess();
    } catch (err) {
      alert('Hata: ' + err.response?.data?.error);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-large" onClick={(e) => e.stopPropagation()}>
        <h3>{facility ? '✏️ Tesis Düzenle' : '➕ Yeni Tesis Ekle'}</h3>
        
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>TESİS ADI *</label>
              <input
                type="text"
                value={formData.facilityName}
                onChange={(e) => setFormData({...formData, facilityName: e.target.value})}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>AÇIKLAMA</label>
            <textarea
              value={formData.description}
              onChange={(e) => setFormData({...formData, description: e.target.value})}
              rows="3"
            />
          </div>

          <div className="form-group">
            <label>ADRES</label>
            <input
              type="text"
              value={formData.address}
              onChange={(e) => setFormData({...formData, address: e.target.value})}
              placeholder="İstanbul, Türkiye"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>ENLEM *</label>
              <input
                type="number"
                step="0.000001"
                value={formData.lat}
                onChange={(e) => setFormData({...formData, lat: e.target.value})}
                placeholder="41.0082"
                required
              />
            </div>
            <div className="form-group">
              <label>BOYLAM *</label>
              <input
                type="number"
                step="0.000001"
                value={formData.lon}
                onChange={(e) => setFormData({...formData, lon: e.target.value})}
                placeholder="28.9784"
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>SAAT DİLİMİ</label>
              <select
                value={formData.timezone}
                onChange={(e) => setFormData({...formData, timezone: e.target.value})}
              >
                <option value="Europe/Istanbul">Europe/Istanbul</option>
                <option value="Europe/London">Europe/London</option>
                <option value="America/New_York">America/New_York</option>
              </select>
            </div>
            <div className="form-group">
              <label>ALAN (m²)</label>
              <input
                type="number"
                value={formData.totalArea}
                onChange={(e) => setFormData({...formData, totalArea: e.target.value})}
                placeholder="2500000"
              />
            </div>
          </div>

          <div className="modal-actions">
            <button type="submit" className="btn">
              {facility ? 'GÜNCELLE' : 'EKLE'}
            </button>
            <button type="button" onClick={onClose} className="btn-secondary">
              İPTAL
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default FacilityModal;
